// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21cpg","clinicsSelect":"styles_clinicsSelect__12ugp"};